module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-4-2-9ca9c6ec9064c0c750b4122fe1a9589e.png";